if (!customElements.get('items-mobile-product-submit')) {
  customElements.define(
    'items-mobile-product-submit',
    class ItemsMobileProductQuantity extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;

          const source = Array.from(event.data.html.querySelectorAll('items-mobile-product-submit')).find(
            (element) => element.dataset.sectionId === this.dataset.sectionId
          );

          if (!source) return;
          this.dataset.variantId = source.dataset.variantId;
          this.innerHTML = source.innerHTML;
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
